import React, { useCallback } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Alert from 'fe-design-base/molecules/Alert';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

const { cx, cxEl } = cxHelpers('UpdateTaxClassificationInfos');

const UpdateTaxClassificationInfos = ({
  user,
  hasITIN,
  hasNoActivePayments,
  hasPaidPayrollRunsForJob,
}) => {
  const fullname = useCallback(
    () => `${user?.get('first_name')} ${user?.get('last_name')}`,
    [user]
  );
  const hasPendingPayrollRuns = !hasNoActivePayments;

  if (!hasPaidPayrollRunsForJob || hasPendingPayrollRuns || hasITIN || !user) {
    return null;
  }

  return (
    <Box className={cx()}>
      <Box mt8 mb={24} data-testid={cxEl('HasPaidPayrollRunsForJob')}>
        <Alert variant="info">
          <Box mr={4}>
            <Text variant="heading4" color="mono900">
              {toI18n(
                'edit_team.individual_drawer.has_paid_payroll_runs_for_job.prefix'
              )}
            </Text>

            <Text variant="body" color="mono900">
              {toI18n(
                'edit_team.individual_drawer.has_paid_payroll_runs_for_job.suffix',
                { props: { fullname: fullname() } }
              )}
            </Text>
          </Box>
        </Alert>
      </Box>
    </Box>
  );
};

UpdateTaxClassificationInfos.propTypes = {
  hasITIN: PropTypes.bool,
  user: ImmutablePropTypes.map,
  hasNoActivePayments: PropTypes.bool,
  hasPaidPayrollRunsForJob: PropTypes.bool,
};

export default UpdateTaxClassificationInfos;
